import "./Button.css";

function Button({id, label , className , type, disabled ,onClick, style}) {
    const classNamePrefix = "button ";

    return (
        <button id={id}type={type} style={style} className={classNamePrefix + className} disabled={disabled} onClick={onClick}>{label}</button>
    )
}

Button.defaultProps = {
    className : "validate",
    type : "button",
    disabled : false,
    style : {}
}

export default Button;
